import { FacebookTestimonialIcon } from "@/components/data-display/Icon";

export const testimonialIconMap = {
  facebook: FacebookTestimonialIcon,
};
